(function() {
    'use strict';
    
a3_pilot_reports.controller('FlightGateCtrl',FlightGateCtrl);
    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name FlightGateCtrl
    * @description 
    *   View all flight connections and search for more possible connecting flights
    * @ngInject
    */
function FlightGateCtrl($scope,$uibModalInstance,flight,FlightGateFactory,SyncLogFactory,FlightFactory,PaxInfoFactory){
					 
		var paxInfo = PaxInfoFactory.getPaxInfoFromStorage(flight.FlightId);
		var flightId = flight.FlightId;
		var items = [];
		var syncLog =  SyncLogFactory.getSyncLog();
		var distinct_gates = [];
		var searchFilters =  flight.FlightsFilters;
		var gates = FlightGateFactory.getAfterSTDFromStorage(flight.ScheduledDeparture,flight.Arrival);	

		$scope.isConnectedFlightClose = isConnectedFlightClose;
		$scope.TimeDifference = TimeDifference;
		$scope.IsOld = IsOld;
		$scope.searchText= '';
		$scope.addFilter = addFilter;
		$scope.removeFilter = removeFilter;
		$scope.cancel = cancel;
		$scope.filters = searchFilters;

		applyFilter();

		if(paxInfo){
			items = paxInfo.TotalFlights;
		}

		for(var i=0;i<gates.length;i++){
				var exists = false;
				for(var j=0;j<items.length;j++){
					if(items[j].FlightNo == gates[i].FlightNo && items[j].Dep == gates[i].Dep){
						var connectingTime = new Date(items[j].STD_lcl);
						var flightGateTime = new Date(gates[i].STD);
						if(connectingTime.getTime()==flightGateTime.getTime()){
							if(items[j].Codeshares.length==0){
								items[j].Codeshares == gates[i].Codeshares;
							}
							exists = true;
							break;
						}
					}
				}
				
				if(!exists){
					var distinct_gate = 
					{ 
						FlightNo :  gates[i].FlightNo , Gate : gates[i].DepGate  ,
						Arr: gates[i].Arrival ,STD_lcl: gates[i].STD_lcl,
						STD : gates[i].STD,
						pax : null ,Codeshares : gates[i].Codeshares,
						UpdatedDate : gates[i].lastUpdate
					}
					distinct_gates.push(distinct_gate);
				}
		}

		var flightArrivalTime =  new Date(flight.ScheduledArrival).getTime();
		$scope.hasGates = distinct_gates.length>0;
		$scope.items = items.sort(function(a, b){return (new Date(a.STD).getTime())- (new Date(b.STD).getTime())});
		$scope.flightETA = flight.ETA? new Date(flight.ETA).getTime() : flightArrivalTime;
    
        /**
         * Calculates if a connecting flight is departs sort time after fligths arrival 
         * @memberof FlightGateCtrl
         * @param {string} connection Connection STD
         * @return {string} cssClass
         */
        function isConnectedFlightClose(connection){

                if(!connection) {
                    return '';
                }

                var connFlightDate = new Date(connection).getTime();

                if ( $scope.flightETA > connFlightDate)
                    return '';

                if ((connFlightDate -  $scope.flightETA) < 3600001 ) { 
                    return 'bg-bisque';
                }

                if ((connFlightDate -  $scope.flightETA) < 6480000) {
                    return 'bg-cornsilk';
                }

                return '';
}
    
        /**
         * Returns the time difference
         * @memberof FlightGateCtrl
         * @param {string} time Connection STD
         * @return {string} timeDifference
         */
        function TimeDifference(time){

                var timeString = '';
                var sign = '';
                var dayString = null;
                if(time){
                    var connFlightDate = new Date(time);
                    var ms = connFlightDate.getTime() -   $scope.flightETA  ; // this is a time in milliseconds
                    if(ms<0){
                            ms = -ms;
                            sign = "-";
                    }

                    var days = Math.floor(ms / (24*60*60*1000));
                    days = days<0? days+1:days;
                    var daysms=ms % (24*60*60*1000);
                    var  hours = Math.floor((daysms)/(60*60*1000));
                    var hoursms=ms % (60*60*1000);
                    var minutes = Math.floor((hoursms)/(60*1000));
                    timeString = '<strong>'+ sign + (hours > 0 ?  ("0" + hours).substr(-2) + ":" : '') + ("0" + minutes).substr(-2) + '\'' + '<strong>';
                    dayString = ' <span class="badge">' +days  + 'd</span>';
                }
                return timeString + ((days && days!=0) ? dayString : '');
}

        /**
         * Checks if the data are new
         * @memberof FlightGateCtrl
         * @param {string} time timestamp
         * @return {boolean} IsOld
         */
        function IsOld(time){
                IsOld=false;
                if(time){
                    var now = new Date();
                    var timeDate = new Date(time);
                    var diff =  now.getTime() - timeDate.getTime();
                    if(diff>3600000){
                        IsOld=true;
                    }
                }
                return IsOld;
}
    
         /**
         * Apply given filters to show connectings flights
         * @memberof FlightGateCtrl
         */
        function applyFilter(){
                var newFlightgates = [];
                if(searchFilters.length>0){
                    for(var i = 0 ; i<distinct_gates.length ; i++){
                        for(var j = 0 ; j<searchFilters.length ; j++){ 
                            var row = distinct_gates[i].FlightNo + ","+  distinct_gates[i].Codeshares.toString();
                            if(row.indexOf(searchFilters[j].toString()) >= 0){
                                newFlightgates.push(distinct_gates[i]);
                                break;
                            } 
                        }
                    }
                }
                $scope.gates = newFlightgates.sort(function(a, b){return (new Date(a.STD).getTime())- (new Date(b.STD).getTime())});
            }
    
        /**
         * Add a filter
         * @memberof FlightGateCtrl
         * @param {string} searchText Search text
         */
        function addFilter (searchText){
                if(searchText.trim().length>0){
                    var exists = false;
                    for(var i = 0 ; i<$scope.filters.length ; i++){
                        if($scope.filters[i]==searchText.toString().toUpperCase()){
                            exists = true;
                            break;
                        }
                    }
                    if (!exists){
                        var flight = FlightFactory.getFlightFromStorage(flightId);
                        searchFilters.push(searchText.toString().toUpperCase());
                        flight.FlightsFilters = searchFilters;
                        FlightFactory.updateFlight(flight);
                        $scope.filters = searchFilters;          
                    }
                    $scope.searchText = "";
                    applyFilter();
                }
}
        /**
         * Remove a filter
         * @memberof FlightGateCtrl
         * @param {item} string filter
         */
        function removeFilter (item){
                var flight = FlightFactory.getFlightFromStorage(flightId);
                var index = searchFilters.indexOf(item);
                searchFilters.splice(index,1);
                flight.FlightsFilters = searchFilters;
                FlightFactory.updateFlight(flight);
                $scope.filters = searchFilters;
                applyFilter();
}
    
        /**
         * Close the modal
         * @memberof FlightGateCtrl
         */
        function cancel() {
                $uibModalInstance.close($scope.gates);
}
	}
    
})();